import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52cfb07d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login_forget_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"login_forget_title\" data-v-52cfb07d>パスワードをお忘れの方</h1><p class=\"login_forget_description\" data-v-52cfb07d><span class=\"login_forget_description_punctuation\" data-v-52cfb07d>パスワードをお忘れの方は、</span><span class=\"login_forget_description_punctuation\" data-v-52cfb07d>登録メールアドレスをご入力のうえ</span><span class=\"login_forget_description_punctuation\" data-v-52cfb07d>「送信」ボタンを押してください</span></p>", 2)
const _hoisted_4 = { class: "login_forget_input" }

import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import { postPasswordReissue } from '@/api/accountEndpoint';
import { ref } from 'vue';
import { useField, useForm } from 'vee-validate';
import { useRouter } from 'vue-router';
import { validationRuleHelper } from '@/utils/validationRule';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForgetView',
  setup(__props) {

const router = useRouter();
const isLoading = ref(false);

const { meta } = useForm();

const { value: mailAddress } = useField<string>('mailAddress', validationRuleHelper({ required: true, email: true }));

const send = async () => {
  isLoading.value = true;

  try {
    // メールを送信
    await postPasswordReissue(mailAddress.value);
    router.push({ name: 'a21' });
  } finally {
    isLoading.value = false;
  }
};

const back = () => {
  // ログイン画面へ遷移
  router.push({ name: 'a10' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseTextForm, {
          placeholder: "メールアドレス",
          type: "email",
          modelValue: _unref(mailAddress),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(mailAddress) ? (mailAddress).value = $event : null))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(BaseButton, {
        class: "login_forget_button",
        disabled: !_unref(meta).valid,
        onClick: send
      }, {
        default: _withCtx(() => [
          _createTextVNode("送信")
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(BaseButton, {
        class: "login_forget_button",
        theme: "secondary",
        onClick: back
      }, {
        default: _withCtx(() => [
          _createTextVNode("ログインへ戻る")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})